import DataGrid, { Button, Column, Paging } from 'devextreme-react/data-grid';
import React, { useEffect, useMemo, useState } from 'react';

import { IconButton } from '@material-ui/core';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import notify from 'devextreme/ui/notify';
import { array, object, shape } from 'prop-types';
import API from '../../../../services/API';
import PopupUserTraining from '../popups/PopupUserTraining';
import PopupUserTrainingDelete from '../popups/PopupUserTrainingDelete';
import {
  Container,
  DatagridContainer,
  Section,
  SectionHeader,
  Title,
} from './styles';

function TrainingUsersGrid({ data, trainings, ACL }) {
  const [popupUserTrainingVisible, setPopupUserTrainingVisible] = useState(
    false
  );
  const [popupDeleteVisible, setPopupDeleteVisible] = useState(false);
  const [currentUserTraining, setCurrentUserTraining] = useState(null);
  const [userTrainingList, setUserTrainingList] = useState(null);
  const trainingData = data?.data;

  async function fetchUserTrainingData() {
    if (trainingData?.TrainingId) {
      const { data: userTrainingData } = await API.sendRequest(
        `UserTraining/ListByTraining/${trainingData?.TrainingId}`,
        'GET'
      );
      setUserTrainingList(userTrainingData);
    }
  }

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      fetchUserTrainingData();
    }

    return () => {
      isSubscribed = false;
    };
    // eslint-disable-next-line
  }, []);

  function handleOpenPopupUserTraining({ data, type }) {
    if (trainingData?.Active) {
      setCurrentUserTraining({ data, type });
      setPopupUserTrainingVisible(true);
    } else {
      notify('You cannot add staff to non-active trainings', 'error', 5000);
    }
  }

  function handleClosePopupUserTraining() {
    setPopupUserTrainingVisible(false);
    setCurrentUserTraining(null);
  }
  function handleOpenPopupDelete(data) {
    setCurrentUserTraining(data);
    setPopupDeleteVisible(true);
  }

  function handleClosePopupDelete() {
    setPopupDeleteVisible(false);
    setCurrentUserTraining(null);
  }

  return (
    <>
      {popupUserTrainingVisible && (
        <PopupUserTraining
          currentUserTraining={currentUserTraining}
          visible={popupUserTrainingVisible}
          refetch={() => fetchUserTrainingData()}
          onClose={() => handleClosePopupUserTraining()}
          trainingId={trainingData.TrainingId}
          trainings={trainings}
        />
      )}
      {popupDeleteVisible && (
        <PopupUserTrainingDelete
          currentUserTraining={currentUserTraining}
          visible={popupDeleteVisible}
          refetch={() => fetchUserTrainingData()}
          onClose={() => handleClosePopupDelete()}
        />
      )}
      <Container>
        <Section>
          <SectionHeader>
            <Title>Staff</Title>
            {(ACL?.Update || ACL?.Admin) && (
              <IconButton
                aria-label="plus"
                size="small"
                onClick={(e) =>
                  handleOpenPopupUserTraining({
                    data: e?.row?.data,
                    type: 'NEW',
                  })
                }
              >
                <AddBoxOutlinedIcon />
              </IconButton>
            )}
          </SectionHeader>
          <DatagridContainer>
            {useMemo(
              () => (
                <DataGrid
                  height={300}
                  dataSource={userTrainingList}
                  keyExpr="UserTrainingId"
                  showBorders
                  selection={{
                    mode: 'single',
                  }}
                  hoverStateEnabled
                >
                  <Paging enabled={false} />
                  <Column dataField="DisplayName" caption="Name" />
                  <Column
                    caption="Okta Tile"
                    cellRender={(data) => (
                      <div>
                        <div>
                          {
                            data.data.HospitalGroups?.find(
                              (item) =>
                                item?.HospitalGroupId ===
                                data.data?.HospitalGroupId
                            )?.HospitalGroupName
                          }
                        </div>
                      </div>
                    )}
                  />
                  <Column dataField="ScheduledDate" dataType="date" />
                  <Column dataField="CompletedDate" dataType="date" />
                  {(ACL?.Update || ACL?.Admin || ACL?.Delete) && (
                    <Column type="buttons" caption="Actions">
                      {(ACL?.Update || ACL?.Admin) && (
                        <Button
                          icon="edit"
                          text="Edit"
                          onClick={(e) =>
                            handleOpenPopupUserTraining({
                              data: e?.row?.data,
                              type: 'EDIT',
                            })
                          }
                        />
                      )}
                      {(ACL?.Admin || ACL?.Delete) && (
                        <Button
                          icon="trash"
                          text="Delete"
                          onClick={(e) => handleOpenPopupDelete(e?.row?.data)}
                        />
                      )}
                    </Column>
                  )}
                </DataGrid>
              ),
              // eslint-disable-next-line
              [userTrainingList]
            )}
          </DatagridContainer>
        </Section>
      </Container>
    </>
  );
}

TrainingUsersGrid.propTypes = {
  data: shape({
    data: shape({}),
  }).isRequired,
  trainings: array,
  ACL: object.isRequired,
};

TrainingUsersGrid.defaultProps = {
  trainings: [],
};

export default TrainingUsersGrid;
